<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid vehicles-page">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <div class="row center">
                        <Dropdown v-model="selectedOrg" :options="organizations"
                                  optionLabel="display_name" :placeholder="$t('AppVehicle.Organização')"
                                  class="auto-center" :dataKey="'id'"
                                  :filter="true"
                                  @input="saveChosenOptionsToLocalStorage"
                                  style="width: 250px">
                            <template #option="slotProps">
                                <div v-if="loadingOrgs">{{ $t('AppVehicle.Carregando, aguarde') }}</div>
                                <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                    -
                                </div>
                                <div style="padding-right: 20px" v-else>
                                    {{ slotProps.option.display_name }}
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" filterDisplay="row" :filters.sync="filters"
                        :sortOrder="-1" sortField="last_contact" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10,25,50]"
                        :selection.sync="selectedVehicles"
                        responsiveLayout="scroll"
                        :currentPageReportTemplate="$t('AppVehicle.currentPageReportTemplate')"
                        class="p-datatable-striped">
                        <template #header>
                            <div class="vehicle-table__header">
                                <div class="vehicle-table__toolbar">
                                    <Button icon="pi pi-external-link" :label="$t('AppVehicle.Exportar')"
                                            @click="exportCsv" class="vehicle-table__export"/>
                                </div>
                                <Accordion :activeIndex="0" class="vehicle-table__chart">
                                    <AccordionTab>
                                        <app-vehicle-pie-chart :chart_data="inactiveInfo"></app-vehicle-pie-chart>
                                    </AccordionTab>
                                </Accordion>
                            </div>
                        </template>
                        <template #empty>
                            {{$t('AppVehicle.Sem dados para exibir')}}
                        </template>
                        <template #loading>
                             {{$t('AppVehicle.Carregando veículos, por favor aguarde')}}
                        </template>
                        <Column field="last_contact" :header=" $t('AppVehicle.Último Contato')" :styles="{'min-width':'11rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{dateHourFormat(slotProps.data.last_contact)}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="frente_name" :header="$t('AppVehicle.Frente')" :styles="{'min-width':'11rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" v-if="hasFeatureEnabled('MANAGEMENT_VEHICLES_GROUP')">
                            <template #body="slotProps">
                                <span>{{slotProps.data.frente_name}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="location" :header="$t('AppVehicle.Localização')" :styles="{'min-width':'11rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.location}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="identification_number" :header="$t('AppVehicle.Chassis')" :styles="{'min-width':'11rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.identification_number}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="identification" :header="$t('AppVehicle.Identificação')" :styles="{'min-width':'12rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.identification}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="type" :header="$t('AppVehicle.Tipo')" :styles="{'min-width':'10rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.type}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="manufacturer" :header="$t('AppVehicle.Fabricante')" :styles="{'min-width':'10rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.manufacturer}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="model" :header="$t('AppVehicle.Modelo')" :styles="{'min-width':'10rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.model}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_meter" :header="$t('AppVehicle.Horímetro')" :styles="{'min-width':'10rem'}" headerClass="headerClass"
                                :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true">
                            <template #body="slotProps">
                                <span>{{slotProps.data.hour_meter.toFixed(1)}}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="in_operation" headerStyle="{width: '4rem', padding: '0px'}"
                                bodyClass="bodyClass"
                                :bodyStyle="{width: '4rem', padding: '0px'}">
                            <template #header>
                                <MultiSelect v-model="filters['in_operation'].value"
                                             :options="inOperationFilter"
                                             optionValue="value"
                                             optionLabel="label"
                                             id="table-multiselect">
                                </MultiSelect>
                            </template>
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-rounded"
                                        :class="slotProps.data.unavailability_date ? 'p-button-secondary' : 'p-button-success'"
                                        style="margin-right: 5px"
                                        @click="handleEdit(slotProps.data)"/>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
    </div>
</div>
</template>

<script>
import AppTable from "../../common/AppTable";
import {mapGetters} from "vuex";
import {router} from "../../../router";
import maskMacAddress from "../../../mixins/StringsMaskMixin";
import maskCpfCnpj from "../../../mixins/StringsMaskMixin";
import dateHourFormat from "../../../mixins/DateMixin";
import VehiclesService from "../../../services/VehiclesService";
import {STATUS} from "../../../constants/status"
import AppButton from "../../common/AppButton";

import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import ProgressBar from 'primevue/progressbar';
import Button from 'primevue/button'
import appendPercent from '../../../mixins/StringsMixins';
import formatValue from '../../../mixins/ValuesFormat'
import filterValue from "../../../mixins/FilterFunctionsDataTables";
import OrganizationsService from "@/services/OrganizationsService";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
import AppVehiclePieChart from "./AppVehiclePieChart.vue";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import buildPrototype from "../../../utils/inactiveMachinesChart";
import MultiSelect from "primevue/multiselect";
import hasFeatureEnabled from "@/mixins/OrganizationFeatureFlagsMixin";
import i18n from "@/i18n";
const DATE_FILTER = 'DATE FILTER';
const HOUR_METER_FILTER = 'HOUR METER FILTER';

export default {
    mixins: [maskMacAddress, dateHourFormat, maskCpfCnpj, appendPercent, formatValue, filterValue, orderCustomFieldByNaturalOrder, exportJsonToCsv, buildPrototype, hasFeatureEnabled],
    created() {
        this.organizationsService = new OrganizationsService();
        this.vehiclesService = new VehiclesService();
    },
    mounted: function () {
        this.getOrganizations();
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.dateHourFormat(value).includes(filter);
        });
        FilterService.register(HOUR_METER_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.formatValue(value).includes(filter);
        });
    },
    data() {
        return {
            inOperationFilter: [
                {label:  i18n.t('AppVehicle.Em Operação'), value: 'IN_OPERATION'},
                {label:  i18n.t('AppVehicle.Fora de Operação'), value: 'OUT_OF_OPERATION'},
            ],
            inOperationValue: null,
            status_list: STATUS,
            selectedVehicles: [],
            vehiclesService: null,
            filters: {
                'last_contact': {value: null, matchMode: DATE_FILTER},
                'frente_name': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'location': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'identification_number': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'identification': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'organization': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'type': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'manufacturer': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'model': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'hour_meter': {value: null, matchMode: HOUR_METER_FILTER},
                'in_operation': {value: ['IN_OPERATION'], matchMode: FilterMatchMode.IN}
            },
            loading: false,
            gridData: [],
            organizationsService: null,
            loadingOrgs: false,
            selectedOrg: null,
            organizations: [],
            storedChosenOptions: {},
            inactiveInfo: [],
        }
    },
    methods: {
        exportCsv(){
            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.gridData));

            tempData.forEach(data => {
                data.last_contact = this.dateHourFormat(data.last_contact);
                data.status = data.unavailability_date ? this.$t('AppVehicle.Fora de Operação') : this.$t('AppVehicle.Em Operação')
                csvData.push(data);
            });

            let csvFields = ['last_contact', 'location', 'identification_number', 'identification', 'type', 'manufacturer', 'model', 'hour_meter', 'status'];
            let csvLabels = [this.$t('AppVehicle.Último Contato'), this.$t('AppVehicle.Localização'), this.$t('AppVehicle.Chassis'), this.$t('AppVehicle.Identificação'),this. $t('AppVehicle.Tipo'), this.$t('AppVehicle.Fabricante'), this.$t('AppVehicle.Modelo'), this.$t('AppVehicle.Horímetro'), this.$t('AppVehicle.Status')];

            if (this.hasFeatureEnabled('MANAGEMENT_VEHICLES_GROUP')) {
                csvFields.splice(1, 0, 'frente_name');
                csvLabels.splice(1, 0, this.$t('AppVehicle.Frente'));
            }

            this.exportJsonToCsv(csvFields, csvLabels, csvData, "vehicles");
        },
        getOrganizations() {
            let vm = this;
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                    vm.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppVehicle.Operação falhou'),
                        detail: this.$t('AppVehicle.Não foi possível buscar organizações'),
                        life: 5000
                    });
                    console.log(error)
                }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        getNumberOfSections(sectionsData) {
            if (!sectionsData || sectionsData.length === 0) {
                return '';
            }

            let numberOfSectionsText = '';
            sectionsData.forEach(section => {
                let numberOfInnerSections = 0;
                section.forEach(innerSection => {
                    numberOfInnerSections++;
                })
                numberOfSectionsText += numberOfInnerSections + ',';
            })
            return numberOfSectionsText.slice(0, -1);
        },
        handleEdit(value) {
            router.push({name: 'vehicles-edit', params: {id: value.id}});
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        getLastConnections() {
            let prototype = this.buildPrototype();
            let day = 86400;

            if (this.gridData) {
                this.gridData.forEach(val => {
                    if (val.unavailability_date) {
                        prototype[6].y += 1;
                        return;
                    }

                    if (!val.last_contact) {
                        prototype[5].y += 1;
                        return;
                    }

                    let diff = ((Date.now() / 1000) - val.last_contact);

                    if (diff <= day / 2) {
                        prototype[0].y += 1;
                        return;
                    }
                    if (diff <= day) {
                        prototype[1].y += 1;
                        return;
                    }
                    if (diff <= 2 * day) {
                        prototype[2].y += 1;
                        return;
                    }
                    if (diff <= 5 * day) {
                        prototype[3].y += 1;
                        return;
                    }
                    if (diff <= 10 * day) {
                        prototype[4].y += 1;
                        return;
                    }

                    prototype[5].y += 1;
                })
            }

            return prototype;
        },
    },
    watch: {
        selectedOrg: function (val) {
            this.loading = true
            this.vehiclesService.getVehiclesByOrgV3(val.id)
                .then(data => {
                    data.forEach(data => {
                        data.location = data.city ? data.city + " (" + data.state + ')' : null
                        data.hour_meter = data.hour_meter === undefined ? 0 : data.hour_meter;
                        data.in_operation = data.unavailability_date ? 'OUT_OF_OPERATION' : 'IN_OPERATION';
                    })
                    this.gridData = data;
                    this.inactiveInfo = this.getLastConnections()
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 403) {
                            this.$toast.add({
                                severity: 'error',
                                summary: this.$t('AppVehicle.Você não tem acesso a esssa funcionalidade'),
                                life: 5000
                            });
                        } else {
                            this.$toast.add({
                                severity: 'error',
                                summary: this.$t('AppVehicle.Não foi possivel completar a operação, tente novamente'),
                                life: 5000
                            });
                        }
                    } else {
                        this.$toast.add({
                            severity: 'error',
                            summary: this.$t('AppVehicle.Não foi possivel completar a operação, tente novamente'),
                            life: 5000
                        });
                    }

                }).finally(() => {
                    this.loading = false;
                }
            );
        }
    },
    components: {
        MultiSelect,
        AppTable,
        DataTable,
        Column,
        InputText,
        Calendar,
        Dropdown,
        ProgressBar,
        Button,
        AppButton,
        Dialog,
        Accordion,
        AccordionTab,
        AppVehiclePieChart
    },
    computed: {
        ...mapGetters([
            'getCurrentOrganization'
        ]),
    },

}
</script>

<style lang="scss">
@import "./src/assets/styles/primevue";

/* table card chrome */
.vehicles-page .data-table-width.card {
    border: 1px solid #e8ecee;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, .06);
    overflow: hidden;
}

/* subtle header row + row hover, scoped to this screen only */
.vehicles-page .p-datatable .p-datatable-thead > tr > th {
    background: #f7f9fa !important;
}

.vehicles-page .p-datatable .p-datatable-tbody > tr:hover > td {
    background: rgba(60, 190, 180, .07) !important;
}

/* table header toolbar (export + chart) */
.vehicle-table__header {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: .5rem;
    padding: .5rem;
}

.vehicle-table__toolbar {
    display: flex;
    justify-content: flex-end;
}

.vehicle-table__export {
    font-size: 13px;
    height: 41px;
}

.vehicle-table__chart {
    width: 100%;
}

@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
